import { render } from "./score.vue?vue&type=template&id=6fbb8a5c&scoped=true"
import script from "./score.vue?vue&type=script&lang=js"
export * from "./score.vue?vue&type=script&lang=js"

import "./score.vue?vue&type=style&index=0&id=6fbb8a5c&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbb8a5c"]])

export default __exports__